import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthService } from '../auth.service';
import { catchError, Subscription, tap } from 'rxjs';
import { FlowComponent } from '../controls/flow/flow.component';
import { RecoveryFlow, UpdateRecoveryFlowBody } from '../../../sdk/kratos';
import { HttpErrorResponse } from '@angular/common/http';
import { MiraLogoComponent } from '../../ui/mira-logo/mira-logo.component';
import { ThemeToggleComponent } from '../../ui/theme-toggle/theme-toggle.component';

@Component({
    selector: 'app-recovery',
    imports: [
      MiraLogoComponent,
      ThemeToggleComponent,
        FlowComponent,
        RouterLink
    ],
    templateUrl: './recovery.component.html',
    styleUrl: './recovery.component.less'
})
export class RecoveryComponent implements OnInit, OnDestroy {

  private subscription = new Subscription();

  flow?: RecoveryFlow;

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private authService: AuthService) {
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    if (this.flow) {
      return;
    }
    const paramMap = this.activatedRoute.snapshot.queryParamMap;
    const flowId = paramMap.get('flow') || undefined;
    const returnTo = paramMap.get('return_to') || undefined;
    this.subscription.add(
      this.authService.createOrGetRecoveryFlow(flowId, returnTo)
        .pipe(tap((data) => {
          this.flow = data;
        }), catchError((err: HttpErrorResponse) => {
          return this.authService.handleGetFlowError(err, 'recovery', () => {
            this.flow = undefined;
          });
        }))
        .subscribe({
          next: (data) => {},
          error: (err: HttpErrorResponse) => {
            // If the previous handler did not catch the error it's most likely a form validation error
            if (err.status === 400) {
              // Yup, it is!
              this.flow = err.error as RecoveryFlow;
              return;
            }

            console.log(err);
            return;
          }
        })
    );
  }

  onSubmit(values: UpdateRecoveryFlowBody): void {
    console.log(values);
    this.subscription.add(
      this.authService.updateRecoveryFlow(values, String(this.flow?.id))
        .pipe(tap((data) => {
          this.flow = data;
        }), catchError((err: HttpErrorResponse) => {
          return this.authService.handleGetFlowError(err, 'recovery', () => {
            this.flow = undefined;
          });
        }))
        .subscribe({
          next: () => {},
          error: (err: HttpErrorResponse) => {
            switch (err.status) {
              case 400:
                // Status code 400 implies the form validation had an error
                this.flow = err.error as RecoveryFlow;
                return;
            }

            console.log(err);
          }
        })
    );
  }
}
